{
  "satis_urun": {
    "Baslik": "Sales Products",
    "Ad": "Product Name",
    "Firma Adı": "Company Name",
    "Birim": "Currency",
    "Komisyon": "Commission",
    "Komisyon SM": "Commission SM",
    "Durum": "Status",
    "Arama": "Search",
    "Ara": "Search",
    "Temizle": "Clear",
    "Kapat": "Close",
    "Yenile": "Refresh",
    "Data Yenile": "Refresh Data",
    "Ekle": "Add",
    "Filtrele": "Filter",
    "Duzenle": "Edit",
    "Sil": "Delete",
    "Kaydet": "Save",
    "Guncelle": "Update",
    "Vazgec": "Cancel",
    "Iptal": "Cancel",
    "Birim Seçimi": "Currency Selection",
    "TL": "TL",
    "Dolar": "Dollar",
    "Hepsi": "All",
    "Aktif": "Active",
    "Pasif": "Passive",
    "ARA": "Search",
    "Komisyonlar": "Commission Ranges",
    "Kopyalama": "Target Copying",
    "Kaynak Ürün": "Source Product",
    "Kaynak Ünvan": "Source Title",
    "Hedef Ürün": "Target Product",
    "Hedef Ünvan": "Target Title",
    "KopyalaUyari": "Attention! Old commission records in the target product and title will be deleted.",
    "Kopyala": "Copy",
    "Islemler": "Actions"
  }
}
